


























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import {mdiSvg} from '@/core';

import {MediaItem} from '../interfaces/MediaItem';

@Component({})
export default class MediaItemModal extends Vue {
  @Prop() mediaItem!: MediaItem | null;

  @Prop() isOpen!: boolean;

  svgIcons = mdiSvg;

  zoomedRank: number | null = null;

  @Watch('mediaItem')
  @Watch('isOpen')
  resetZoom(): void {
    this.zoomedRank = null;
  }

  toggleZoom(rank: number): void {
    this.zoomedRank = this.zoomedRank === rank ? null : rank;
  }
}
